<!-- TEMPLATE -->
<template>
  <div class="role-privileges">
    <div class='row'>
      <div class='small-12 medium-12 large-12 hd-12 columns dashboard-content'>
        <dean-section-title content='true'>
          <span slot='title'>
              <span class='avenir-heavy'>Privileges rol</span>
          </span>
          <dean-section-title-item
              :icon="editIcon"
              :content="true"
              @click.native="sectionRoute('auth.admin.role.privileges.edit')">
            wijzigen
          </dean-section-title-item>
        </dean-section-title>
        <dean-table
            :data='data'
            :columns="columns"
            @column-click='columnClick'>
        </dean-table>
        <dean-pagination
            :current-page='tableMetaData.pageNumber'
            :total-items='tableMetaData.totalResults'
            :items-per-page='tableMetaData.itemsPerPage'
            :select-items-per-page='selectItemsPerPage'
            :visible-pages='tableMetaData.visiblePages'
            @page-changed='paginationChanged'
            @items-per-page='itemsPerPageChanged'
        >
        </dean-pagination>
      </div>
    </div>
  </div>
</template>

<!-- SCRIPT -->
<script lang="ts">
  import {Vue, Component} from 'vue-property-decorator';
  import axios from 'axios';
  import deanTableMixin from '@/mixins/deanTableMixin';
  import sideMenuAdminMixin from '@/mixins/sideMenuAdminMixin';
  import {mixins} from 'vue-class-component';

  import {
    editIcon,
    // COMPONENTS
    deanSectionTitle,
    deanSectionTitleItem,
    deanTable,
    deanPagination,
  } from '@deanone/dean-components';

  @Component({
    components: {
      deanSectionTitle,
      deanSectionTitleItem,
      deanTable,
      deanPagination,
    },
  })

  export default class List extends mixins(deanTableMixin, sideMenuAdminMixin) {
    // DATA
    public editIcon: object = editIcon;
    public sideMenuTitle: string = 'Rol';
    public role: any = [];
    public data: Array<{
      id: string,
      name: string,
      action: string,
    }> = [];

    public columns: any = {
      name: {
        content: 'naam',
        align: 'left',
        sort: false,
        dql: 'name',
      },
      action: {
        content: 'actie',
        align: 'center',
        sort: false,
        dql: 'action',
      },
    };

    // COMPUTED
    get tableMetaData() {
      return this.pageMeta;
    }

    public tableName(): string {
      return 'auth-roles-privileges';
    }

    // METHODS
    public created() {
      this.$store.dispatch('setLoadOverlay', true);

      this.setDefaultSort('name');

      this.loadRoleInfo();

      this.$store.dispatch('setLoadOverlay', false);

      this.buildSideMenuAdmin(this.sideMenuTitle, this.sideMenuRoleSection);
    }

    public loadRoleInfo() {
      const url = '/-/trade/api/admin.role.info';

      axios.post(url, {
        id: this.$route.params.id,
      }).then(
        (response) => {
          this.role.id = response.data.id;
          this.role.name = response.data.name;

          this.sideMenuTitle = 'Rol ' + this.role?.name;

          this.data = response.data.permissions.map((privilege: any) => {
            return {
              id: privilege.id,
              name: privilege.name,
              action: privilege.action,
            };
          });
        },
        (error) => {
          this.$toast(this.$store.state.main.notification.messages.couldNotReceiveData);
        },
      );
    }

    public sectionRoute(name: string) {
      this.$router.push({name});
    }
  }
</script>
<!-- STYLE -->
<style lang="scss" scoped>

</style>
